import React from 'react';
import { blockStyle, labelStyle, inputStyle, styles } from './trainAgentStyles';

export function TrainAgentExamplesBlock({ vm }) {
  const { examples, setExample, removeExample, addExample } = vm;
  return (
    <div style={blockStyle}>
      <label style={labelStyle}>5. Exemplos (pergunta → resposta)</label>
      {examples.map((ex, i) => (
        <div key={i} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'flex-start' }}>
          <input
            value={ex.input}
            onChange={(e) => setExample(i, 'input', e.target.value)}
            placeholder="Pergunta"
            style={{ ...inputStyle, flex: 1 }}
          />
          <input
            value={ex.output}
            onChange={(e) => setExample(i, 'output', e.target.value)}
            placeholder="Resposta"
            style={{ ...inputStyle, flex: 1 }}
          />
          <button type="button" onClick={() => removeExample(i)} style={styles.removeBtn}>
            −
          </button>
        </div>
      ))}
      <button type="button" onClick={addExample} style={styles.smallButton}>
        + Adicionar exemplo
      </button>
    </div>
  );
}
